import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// ── Styled Components ─────────────────────────────────────────

const PageWrapper = styled(Box)({
  backgroundColor: "#f5f5f5",
  padding: "60px 20px 0",
});

const CoupleRow = styled(Box)({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  gap: "0",
  maxWidth: "700px",
  margin: "0 auto",
});

const PersonBlock = styled(Box)({
  flex: 1,
  textAlign: "center",
});

const PersonImage = styled("img")({
  width: "100%",
  maxWidth: "220px",
  height: "220px",
  objectFit: "cover",
  display: "block",
  margin: "0 auto",
});

const HeartDivider = styled(Box)({
  display: "flex",
  alignItems: "flex-end",
  paddingBottom: "60px",
  paddingLeft: "8px",
  paddingRight: "8px",
});

const HeartBubble = styled(Box)({
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  backgroundColor: "#e53935",
  color: "white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "1rem",
  flexShrink: 0,
});

const PersonName = styled(Typography)({
  fontSize: "1.1rem",
  fontWeight: "bold",
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  color: "#333",
  marginTop: "20px",
  marginBottom: "2px",
});

const PersonNickname = styled(Typography)({
  fontSize: "0.78rem",
  fontStyle: "italic",
  color: "#aaa",
  marginBottom: "12px",
});

const PersonBio = styled(Typography)({
  fontSize: "0.75rem",
  color: "#999",
  lineHeight: 1.9,
  maxWidth: "220px",
  margin: "0 auto",
});

// Section photo de fond en bas
const HeroBottom = styled(Box)({
  width: "100%",
  height: "260px",
  backgroundImage: "url('/assets/IMG_2585.jpeg')", // ← ta photo
  backgroundSize: "cover",
  backgroundPosition: "center",
  marginTop: "60px",
  filter: "brightness(0.75)",
});

// ── Composant ─────────────────────────────────────────────────

export default function Couple() {
  const { t } = useTranslation();
  return (
    <Box>
      <PageWrapper>
        <CoupleRow>
          {/* Lui */}
          <PersonBlock>
            <PersonImage src="/assets/IMG_2585.jpeg" alt="W" /> {/* ← photo de lui */}
            <PersonName>W</PersonName> {/* ← son prénom */}
            <PersonNickname>{t("couple.nickname")}</PersonNickname>
            <PersonBio>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
              aliquet condimentum nibh iaculis dapibus. Nullam nibh bibendum
              dui. Ut vel tempus accumsan, efficitur dolor fermentum. Phasellus
              condimentum, ex vitae commodo. Phasellus condimentum, mauris.
            </PersonBio>
          </PersonBlock>

          {/* Cœur central */}
          <HeartDivider>
            <HeartBubble>♥</HeartBubble>
          </HeartDivider>

          {/* Elle */}
          <PersonBlock>
            <PersonImage src="/assets/IMG_2585.jpeg" alt="D" /> {/* ← photo d'elle */}
            <PersonName>D</PersonName> {/* ← son prénom */}
            <PersonNickname>{t("couple.nickname")}</PersonNickname>
            <PersonBio>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
              aliquet condimentum nibh iaculis dapibus. Nullam nibh bibendum
              dui. Ut vel tempus accumsan, efficitur dolor fermentum. Phasellus
              condimentum, ex vitae commodo. Phasellus condimentum, mauris.
            </PersonBio>
          </PersonBlock>
        </CoupleRow>

        {/* Photo de fond en bas */}
        <HeroBottom />
      </PageWrapper>
    </Box>
  );
}
